/** Thrown for a change attempted without a connection (the app is read-only). */
export class OfflineError extends Error {
  constructor() {
    super("OFFLINE");
    this.name = "OfflineError";
  }
}

export const isOfflineError = (error: unknown) => error instanceof OfflineError;
